'use client';

import { cn } from '@/lib/utils';

interface CornerBracketsProps {
  size?: number;
  className?: string;
  color?: string;
}

export function CornerBrackets({
  size = 14,
  className,
  color = 'rgba(255, 215, 120, 0.55)',
}: CornerBracketsProps) {
  const d = size;
  return (
    <div className={cn('pointer-events-none absolute inset-0', className)} aria-hidden>
      {(['tl', 'tr', 'bl', 'br'] as const).map((corner) => {
        const rotate = {
          tl: 0,
          tr: 90,
          br: 180,
          bl: 270,
        }[corner];
        const pos = {
          tl: { top: -1, left: -1 },
          tr: { top: -1, right: -1 },
          bl: { bottom: -1, left: -1 },
          br: { bottom: -1, right: -1 },
        }[corner];
        return (
          <svg
            key={corner}
            width={d}
            height={d}
            viewBox="0 0 16 16"
            style={{
              position: 'absolute',
              ...pos,
              transform: `rotate(${rotate}deg)`,
            }}
          >
            <path
              d="M1 7 L1 1 L7 1"
              stroke={color}
              strokeWidth="1"
              fill="none"
              strokeLinecap="square"
            />
            <rect x="0.5" y="0.5" width="2" height="2" fill={color} opacity="0.9" />
          </svg>
        );
      })}
    </div>
  );
}
